import React from 'react';
import cx from 'classnames';
import OMInputField from '../OMInputField/OMInputField';
import styles from './OMFormGroup.scss';

const OMFormGroup = (properties) => {
  const { label, isRequired, name, onChange, tooltipMessage, title, value, error, isMobile, touched,
    readOnly, isAccordion, onBlur, onKeyDown, isRtl, className, classNameLabel } = properties;
  return (
    <div className={cx(styles.groupWrapper, className, { [styles.accordionWrapper]: isAccordion })}>
      <div className={cx(styles.label, classNameLabel)}>
        {label} { (isRequired) && (<span className="req">*</span>)}
      </div>
      <div className={cx(styles.field, { [styles.accordion]: isAccordion })}>
        <OMInputField
          type="text"
          placeholder={label}
          name={name}
          onChange={onChange}
          tooltipMessage={tooltipMessage}
          title={title || label}
          showHoverTooltip={!!error}
          isInvalid={!!error && touched}
          value={value}
          validate={val => (isRequired ? !!val : true)}
          isMobile={isMobile}
          readOnly={readOnly}
          onBlur={onBlur}
          onKeyDown={onKeyDown}
          isRtl={isRtl}
        />
      </div>
    </div>
  );
};

export default OMFormGroup;
